import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { getSessionSettingsStorage, setSessionSettingsStorage } from '../../../store/session-storage';
import { useRestaurant } from '../../../contexts/restaurant.context';
import { axiosClient } from '../../../libs/axios';

function Announcement() {
    const [isGroup, setIsGroup] = useState(false);

    const restaurant = useRestaurant();

    const group_id = getSessionSettingsStorage('group_id');
    const group_type = getSessionSettingsStorage('group_type');
    const client_id = getSessionSettingsStorage('client_id');
    const group_starter_name = getSessionSettingsStorage('group_starter_name');

    useEffect(() => {
        if (isGroup !== !!group_id) {
            setIsGroup(!!group_id);
        }
    });

    const {announcement_title, announcement, mobile_announcement_image, announcement_image} = restaurant;
    
    const handleLeaveGroup = () => {
        setSessionSettingsStorage('group_id', null);
        setSessionSettingsStorage('group_type', null);

        setIsGroup(false);
        
        if (window.group_leave_url) {
            axiosClient.get(window.group_leave_url);
        }
    };

    if (!announcement && !announcement_image) {
        return null;
    }

    return (
        <div>
            {announcement_image && (
                <span className={classNames('resto-announcement-image', {'image-full': mobile_announcement_image === 'full'})}>
                    <img className="responsive" src={announcement_image} alt=""/>
                </span>
            )}
            <div className="resto-announcement" style={{width: 100 + '%', overflowWrap: 'break-word', paddingBottom: 0}}>
                <span className="resto-announcement-title">
                {announcement_title}
            </span>
                <span className="resto-announcement-info">
                <div>
                    <p dangerouslySetInnerHTML={{
                        __html: announcement
                    }}/>
                </div>
            </span>
            </div>

            {/*{restaurant.is_enabled_group_order && !isGroup && (*/}
            {/*    <div className="text-center my-3">*/}
            {/*        <a*/}
            {/*            className="btn btn-outline-danger"*/}
            {/*            href={`https://www.fastordernow.com/restaurant/${window.vendor}/group/type`}*/}
            {/*            target="_self"*/}
            {/*        >*/}
            {/*            Start Group Order*/}
            {/*        </a>*/}
            {/*    </div>*/}
            {/*)}*/}
            
            {restaurant.is_enabled_group_order && isGroup && (
                <>
                    {'group' === group_type && (
                        <>
                            <div className="alert alert-info" role="alert">
                                Group Ordering Started by {group_starter_name}
                                <br />One Person Pays Entire Order
                            </div>
                            
                            <div className="d-flex">
                                {/*
                                <a
                                    href={`${window.group_url}?group_id=${group_id}&client=${window.client_id}`}
                                    className="btn btn-outline-danger ml-4"
                                    target="_self"
                                >
                                    View Group Orders
                                </a>
                                */}
                                <button
                                    type="button"
                                    className="btn btn-outline-danger ml-4"
                                    onClick={handleLeaveGroup}
                                >
                                    Leave Group
                                </button>
                            </div>
                        </>
                    )}
                    
                    {'individual' === group_type && (
                        <>
                            <div className="alert alert-info" role="alert">
                                Group Ordering Started by {group_starter_name}
                                <br />Individuals Pay Separately
                            </div>

                            <div className="d-flex">
                                <a
                                    href={`${window.individual_group_url}?group_id=${group_id}&client=${client_id}`}
                                    className="btn btn-outline-danger ml-4"
                                    target="_self"
                                >
                                    Show Group Ordering Link
                                </a>
                                <button
                                    type="button"
                                    className="btn btn-outline-danger ml-4"
                                    onClick={handleLeaveGroup}
                                >
                                    Leave Group
                                </button>
                                {/*
                                <a
                                    href={`${window.individual_group_url}?group_id=${group_id}&client=${window.client_id}`}
                                    className="btn btn-outline-danger ml-4"
                                    target="_self"
                                >
                                    View Group Orders
                                </a>
                                */}
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
}

export default Announcement;